import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import store, {persistor} from "./redux/store";
import App from "./app/App";
// import "./index.scss"; // Standard version
import "./sass/style.react.rtl.css"; // RTL version
import "./core/_assets/plugins/keenthemes-icons/font/ki.css";
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./core/_assets/plugins/flaticon/flaticon.css";
import "./core/_assets/plugins/flaticon2/flaticon.css";
// Datepicker
import "react-datepicker/dist/react-datepicker.css";
import {AppLayoutProvider, AppSplashScreenProvider} from "./core/layout";
import {AppI18nProvider} from "./core/i18n";
import "./sass/custom.css";

const {PUBLIC_URL} = process.env;

ReactDOM.render(
    <AppI18nProvider>
        <AppLayoutProvider>
            <AppSplashScreenProvider>
                <App store={store} persistor={persistor} basename={PUBLIC_URL}/>
            </AppSplashScreenProvider>
        </AppLayoutProvider>
    </AppI18nProvider>,
    document.getElementById("root")
);
